export const baseReducer = (initialState, actionHandlerMap) => {
  return (state = initialState, action) => {
    const actionHandler = actionHandlerMap[action.type];
    if (!actionHandler) {
      return state;
    }
    return actionHandler(state, action);
  };
};
